import clp from "@/_clp.js";
import customfn from "@/_functions.js";
import {Modal} from 'bootstrap';

$(document).ready(function(){
    if($(document).find('body').hasClass('centre-inventory_overview')){
        $( document ).ajaxComplete(function( event, xhr, settings ) {
            if(settings.url.indexOf('?search') > -1 ||
                settings.url.indexOf('?sort') > -1 ||
                settings.url.indexOf('?page') > -1 ||
                settings.url.indexOf('?filter') > -1 ||
                settings.url.indexOf('?amount') > -1){
                setTimeout(function(){
                    clp.getInventoryStatuses();
                }, 500);
            }
        });
    }

    $(document).on('change', '#easy_office_mode_toggle', function() {
        var toggle = $(this),
            autolock = $('#autolocking_toggle'),
            autolock_label = $('.autolocking_toggle_label'),
            autolocking_row = $('.autolocking_row'),
            c = 'checked',
            d = 'disabled';

        if (toggle.is(':checked')) {
            // Enable autolocking toggle
            autolock.removeAttr(d).prop(d, false);
            if (autolock.attr('data-initial-value') && autolock.data('initial-value') == "1") {
                autolock.attr(c, c).prop(c, true);
            }
            autolock_label.removeAttr(d).prop(d, false).removeClass(d);
            autolocking_row.removeClass(d);
        } else {
            // Disable (and reset?) autolocking toggle
            autolock.attr(d, d).prop(d, true).removeAttr(c).prop(c, false);
            autolock_label.attr(d, d).prop(d, true).addClass(d);
            autolocking_row.addClass(d);
        }

    });

    $(document).on('change', '#autolocking_toggle', function() {
        var toggle = $(this);
        // Reset initial value if toggled manually
        if (toggle.is(':checked')) {
            toggle.attr('data-initial-value', '1').data('initial-value', '1');
        } else {
            toggle.attr('data-initial-value', '0').data('initial-value', '0');
        }
    });

    $(document).on('submit', '#manage_eom_schedule_form', function(event) {

        event.preventDefault();
        var modalEl = $(this).closest('.modal')[0];
        var url = $(this).attr('action');
        var formFields = $(this).serialize();

        customfn.postModal(url, formFields, {keyboard: false, backdrop: 'static'}, function(data){
            if(data.html) {
                $('.jumbotron .sub-data .eom_schedule_row').remove();
                $('.jumbotron .sub-data').append($(data.html));
                // Reload after "2 seconds"
                setTimeout(function(){$('.eom_schedule_reloaded').removeClass('eom_schedule_reloaded'); $('.eom_schedule_row').find('.fa.fa-cog.fa-spin').remove();}, 2000);

                if (modalEl) {
                    const modalInstance = Modal.getOrCreateInstance(modalEl);
                    modalInstance.hide();
                }
            }
        });

    });


});
